import './App.css';

function App() {
  return (
    <div className="privacy-container">
      <h1>Takva Saati Uygulaması Gizlilik Politikası</h1>
      <p>
        Bu gizlilik politikası, Takva Saati mobil uygulamasını kullanımınız sırasında işlenen kişisel verilerinize dair bilgileri içermektedir.
        Uygulama, kullanıcıların günlük ibadetlerini takip etmelerine ve dini bilgilere kolayca erişmelerine yardımcı olmak amacıyla tasarlanmıştır.
      </p>
      
      <h2>1. Kişisel Verilerin İşlenmesi ve Amaçları</h2>
      <p>Takva Saati uygulaması kapsamında aşağıdaki amaçlarla bazı kişisel verileriniz işlenebilir:</p>
      <ul>
        <li>Uygulamanın temel fonksiyonlarını yerine getirebilmesi,</li>
        <li>Namaz vakitleri ve diğer dini bilgilerle ilgili bildirimleri alabilmeniz,</li>
        <li>Uygulamanın performansının artırılması ve kullanıcı deneyiminin geliştirilmesi,</li>
        <li>Hukuki yükümlülüklerin yerine getirilmesi.</li>
      </ul>
      
      <h2>2. Toplanan Veriler ve Kullanım Şekli</h2>
      <ul>
        <li><strong>Konum Bilgisi:</strong> Namaz vakitlerini doğru hesaplayabilmek için açık rızanız olması durumunda konum bilginiz alınabilir.</li>
        <li><strong>Cihaz Bilgileri:</strong> Hata tespiti, performans analizi ve uygulama geliştirme amaçlarıyla cihaz modeli, işletim sistemi sürümü ve kullanım istatistikleri işlenebilir.</li>
        <li><strong>Bildirim Tercihleri:</strong> Kullanıcının belirlediği bildirim ayarları saklanarak, namaz vakitleri veya diğer hatırlatmalar kişiselleştirilebilir.</li>
      </ul>
      
      <h2>3. Açık Rızaya Tabi Olan İşleme Faaliyetleri</h2>
      <p>Takva Saati uygulaması, yalnızca açık rızanız olması halinde bazı verilerinizi işleyebilir:</p>
      <ul>
        <li>Konum Bilgisi: Bulunduğunuz bölgedeki doğru namaz vakitlerini göstermek amacıyla kullanılır.</li>
        <li>Kullanım Verileri: Uygulamanın geliştirilmesi amacıyla kullanım istatistikleri anonim olarak toplanabilir.</li>
      </ul>
      
      <h2>4. Verilerinizin Saklanması ve Paylaşımı</h2>
      <p>Takva Saati uygulaması, kişisel verilerinizi üçüncü taraflarla paylaşmaz ve yalnızca uygulama içi hizmetleri geliştirmek amacıyla işler.</p>
      <p>Verileriniz yalnızca Apple'ın zorunlu kıldığı analiz araçları ve hata izleme sistemleri ile anonim olarak işlenebilir.</p>
      <p>Bulut Hizmetleri kullanılması durumunda, yalnızca sizin erişebileceğiniz şekilde şifrelenmiş olarak saklanır.</p>
      
      <h2>5. İzinler</h2>
      <ul>
        <li><strong>Konum:</strong> Namaz vakitlerini doğru hesaplamak için kullanılabilir (Opsiyoneldir, kullanıcı tarafından devre dışı bırakılabilir).</li>
        <li><strong>Bildirimler:</strong> Namaz vakitleri ve diğer dini hatırlatmalar için kullanılabilir (Kullanıcının onayı ile etkinleştirilir).</li>
        <li><strong>Depolama:</strong> Kullanıcı ayarlarının cihazda saklanabilmesi amacıyla kullanılabilir.</li>
      </ul>
      
      <h2>6. Kullanıcı Hakları</h2>
      <p>Kullanıcılar, KVKK ve ilgili yasalar çerçevesinde aşağıdaki haklara sahiptir:</p>
      <ul>
        <li>Kişisel verilerinin işlenip işlenmediğini öğrenme,</li>
        <li>İşlenmişse buna dair bilgi talep etme,</li>
        <li>Verilerin eksik veya yanlış işlenmiş olması durumunda düzeltilmesini isteme,</li>
        <li>Kişisel verilerinin silinmesini veya yok edilmesini talep etme.</li>
      </ul>
      <p>Bu haklarınızı kullanmak için <a href="mailto:developer@takvasaati.com">developer@takvasaati.com</a> adresine e-posta gönderebilirsiniz.</p>
      
      <h2>7. Bilgilerinizin Güvenliği</h2>
      <p>Takva Saati, en son teknolojik ve idari güvenlik önlemlerini alarak, bilgilerinizi koruma altına alır.</p>
      
      <h2>8. Üçüncü Taraf Bağlantıları</h2>
      <p>Takva Saati, üçüncü taraf web sitelerine yönlendirme içerebilir. Bağlantıya tıkladığınızda, ilgili sitenin gizlilik politikasına tabi olursunuz.</p>
      
      <h2>9. Politikada Yapılacak Değişiklikler</h2>
      <p>Takva Saati Gizlilik Politikası zaman zaman güncellenebilir. Esaslı değişiklikler olması durumunda, uygulama içi bildirimlerle sizi bilgilendirebiliriz.</p>
      
      <h2>İletişim</h2>
      <p>Herhangi bir sorunuz olduğunda bizimle aşağıdaki yollarla iletişime geçebilirsiniz:</p>
      <p><strong>E-posta:</strong> <a href="mailto:developer.takvasaati@gmail.com">developer.takvasaati@gmail.com</a></p>
      <p><strong>Adres:</strong> İstanbul, Türkiye</p>
    </div>
  );
}

export default App;

